import Home from "./components/home";
import Offer from "./components/offer";
import Privacy from "./components/privacy-policy";
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import ProgrammPage from "./components/programm";
import Course from "./components/course";
import Сongratulation from "./components/congratulations";

function App() {
  return (
    <div className="App">
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/programm" element={<ProgrammPage />} />
                <Route path="/congratulation" element={<Сongratulation />} />
                <Route path="/course" element={<Course />} />
                <Route path="/privacy-policy" element={<Privacy />} />
                <Route path="/offer" element={<Offer />} />
            </Routes>
        </BrowserRouter>
    </div>
  );
}

export default App;
